module.exports = __webpack_public_path__ + "static/img/1-1.67107de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/1-1.png
// module id = Yine
// module chunks = 0